import React, { useState, useEffect } from "react";
import AsideLeft from "./AppAdminComponents/AsideLeft";
import NavBarNotificationBar from "./AppAdminComponents/NavBarNotificationBar";
import { getuser } from "../helpers/user.helper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import {
  ActivateUser,
  UpdateTypeUser,
  PaginatedList,
  ChangePassword, deleteItem
} from "../services/user.service";
import Swal from "sweetalert2";
import Loader from "react-loader-spinner";
import Modal from "react-modal";
import Select from "react-select";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { toast } from "react-toastify";
import { post } from "../helpers/api.helper";
import Footer from "../components/Footer";

export default function UsersList() {
  let navigate = useNavigate();
  const [usersResult, setUsersResult] = useState(undefined);
  const [usersResultAux, setUsersResultAux] = useState(undefined);
  const [modalResponsibleIsOpen, setResponsibleModalIsOpen] = React.useState(false);
  const [modalChangePassIsOpen, setChangePassModalIsOpen] = React.useState(false);
  const [selectedGridRow, setSelectedGridRow] = useState(null);
  const [isLoadingChange, setisLoadingChange] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);

  const [user, setUser] = useState("");
  const [cpfInvalid, setInvalidcpf] = useState(false);
  const [isLoader, setIsloader] = useState(false);

  const [senha, setSenha] = useState("");
  const [confirmSenha, setconfirmSenha] = useState("");
  const [divergentPasswords, setDivergentPasswords] = useState(false);

  const [totalPage, setTotalPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [filters, setFilters] = useState();

  async function fetchDataUsers() {
    let users = await PaginatedList(20, 1);
    setUsersResult(users?.data.data);
    setUsersResultAux(users?.data.data);
    setTotalPage(users.data.totalPages);
    setTotalRecords(users.data.totalItems);
  }

  useEffect(() => {
    let user = getuser();
    //Redireciona caso não esteja logado
    if (!user) {
      navigate("/login");
    }

    fetchDataUsers();
  }, [navigate]);

  const showItemClick = (rowData) => {
    navigate(`/users/${rowData.id}`);
  };

  const createNewUserClick = (rowData) => {
    navigate(`/user/create`);
  };

  const activeUser = async (id) => {
    await ActivateUser(id);
  };

  const setConfirmHandleChange = (value) => {
    setconfirmSenha(value);
  };

  const confirmSenhaTest = (value) => {
    setconfirmSenha(value);

    if (senha !== confirmSenha) {
      setDivergentPasswords(true);
    } else {
      setDivergentPasswords(false);
    }
  };

  const handleOnclick = async () => {
    try {
      setIsloader(true);

      let values = {
        password: senha,
      };

      confirmSenhaTest();

      if (senha !== confirmSenha) {
        toast.warning(
          "Campo Senha e confirmação de senha não podem ser diferentes!"
        );
        setIsloader(false);
        return;
      } else if (!senha) {
        toast.info("Campo Senha não pode ser vazio!");
        setIsloader(false);
        return;
      } else if (!confirmSenha) {
        toast.info("Campo Confirmação da senha não pode ser vazio!");
        setIsloader(false);
        return;
      }

      let result = await post("usuario/reset", values);

      if (result.status === 200) {
        toast.success("Sua senha foi atualizada.");
      } else if (result.status === 400) {
        toast.warning("Ocorreu um erro ao alterar sua senha");
      }
      setIsloader(false);
    } catch (error) {
      setIsloader(false);
      toast.warning("Ocorreu um erro ao enviar suas informações");
    }
  };

  const activateUser = (rowData) => {
    Swal.fire({
      title: "<strong>Ativar usuário?</strong>",
      icon: "question",
      html: "Deseja ativar o usuário? ",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim!',
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.value) {
        activeUser(rowData.id);
      }
    });
  };

  const options = [
    { value: "C", label: "Cliente" },
    { value: "R", label: "Representante" },
    { value: "A", label: "Administrador" },
  ];

  const getStatus = (status) => {
    if (status === "EA") {
      return "Aguardando análise";
    } else if (status === "A") {
      return "Cadastro aprovado";
    }
  };

  const getTypeUser = (type) => {
    if (type === "C") {
      return "Cliente";
    } else if (type === "R") {
      return "Representante";
    } else if (type === "A") {
      return "Administrador";
    }
  };

  let renderLoad = () => {
    return (
      <div className="table-footer text-center">
        <Loader
          type="ThreeDots"
          color="#343A40"
          height={100}
          width={100}
          visible={true}
        />
      </div>
    );
  };

  function openResponsibleModal(rowData) {
    setSelectedGridRow(rowData);
    setResponsibleModalIsOpen(true);
  }

  function openChangePassModal(rowData) {
    setSelectedGridRow(rowData);
    setChangePassModalIsOpen(true);
  }

  function closeModal() {
    setResponsibleModalIsOpen(false);
    setChangePassModalIsOpen(false);
  }

  const cancelModal = () => {
    setSelectedGridRow(undefined);
    closeModal();
  };

  const saveDataResponsibleAndCloseModal = async () => {
    let payload = {
      Id: selectedGridRow.id,
      TypeUser: selectedValue.value,
    };

    Swal.fire({
      title: "<strong>Deseja mudar o tipo do usuário?</strong>",
      icon: "question",
      html: "mudar o tipo usuário implica em mudar o que o usuário tem permissão de ver no sistema. ",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim!',
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.value) {
        await UpdateTypeUser(payload);

        Swal.fire("Feito!", "Usuário modificado com sucesso", "success");

        await fetchDataUsers();
      }
    });

    closeModal();
  };

  const changePassAndCloseModal = async () => {
    let payload = {
      id: selectedGridRow.id,
      username: selectedGridRow.cpf,
      password: senha,
    };

    Swal.fire({
      title: "<strong>Deseja mudar a senha do usuário?</strong>",
      icon: "question",
      html: "será necessário informar a nova senha ao usuário para o próximo acesso. ",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim!',
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.value) {
        await ChangePassword(payload);

        Swal.fire("Feito!", "senha alterada com sucesso", "success");

        await fetchDataUsers();
      }
    });

    closeModal();
  };

  const selectHandleChange = (value) => {
    setSelectedValue(value);
  };

  const optionButtons = (rowData, column) => {
    return (
      <div>
        <button
          onClick={() => showItemClick(rowData)}
          title="Visualizar item"
          type="button"
          className="btn btn-icon btn-danger btn-sm"
        >
          <i className="fa fa-edit"></i>
        </button>
        &nbsp;
        <button
          onClick={() => activateUser(rowData)}
          title="Ativar usuário"
          type="button"
          className="btn btn-icon btn-info btn-sm"
        >
          <i className="fa fa-check-square-o"></i>
        </button>
        &nbsp;
        <button
          onClick={() => openResponsibleModal(rowData)}
          title="Vincular responsável"
          type="button"
          className="btn btn-icon btn-warning btn-sm"
        >
          <i className="fa fa-user"></i>
        </button>
        &nbsp;
        <button
          onClick={() => openChangePassModal(rowData)}
          title="Resetar senha"
          type="button"
          className="btn btn-icon btn-danger btn-sm"
        >
          <i className="fa fa-key"></i>
        </button>
        &nbsp;
        {getuser().type === "A" && (
          <button
            onClick={() => handleDeleteItem(rowData)}
            title="Apagar item"
            type="button"
            className="btn btn-icon btn-danger btn-sm"
          >
            <i className="fa fa-trash"></i>
          </button>
        )}
      </div>
    );
  };

  const onPage = async (event) => {
    setFirst(event.first);
    let users = await PaginatedList(event.rows, event.page + 1);
    setUsersResult(users?.data.data);
  };

  const handleDeleteItem = async (item) => {
    Swal.fire({
      title: "<strong>Apagar usuário</strong>",
      icon: "question",
      html: "Deseja remover usuário? ",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim!',
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.value) {
        await deleteItem(item.id);
      }
    });
  };


  const onFilter = async (event) => {
    if (Object.keys(event.filters).length === 0) {
      await fetchDataUsers();
    } else {
      console.log(event);
      const { nome, email } = event.filters;
      if (nome && nome.value.length === 4) {
        const userFilter = usersResultAux.filter(
          (x) => x.nome.toLowerCase().includes(nome.value.toLowerCase())
        );
        setUsersResult(userFilter);
        setTotalRecords(userFilter.length);
      }

      if (email && email.value.length === 4) {
        const userFilter = usersResultAux.filter(
          (x) => x.email.toLowerCase().includes(email.value.toLowerCase())
        );
        setUsersResult(userFilter);
        setTotalRecords(userFilter.length);
      }
    }
    setFilters(event.filters);
  };

  return (
    <>
      <div className="wrapper">
        <Modal
          isOpen={modalResponsibleIsOpen}
          style={{
            content: {
              width: "60%",
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
            },
          }}
          contentLabel="Example Modal"
        >
          <div className="row">
            <div className="col-12">
              <h3>{selectedGridRow?.nome}</h3>
              <div className="form-group">
                <label>Tipo do usuário</label>
                <Select options={options} onChange={selectHandleChange} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <button className="btn btn-primary" onClick={cancelModal}>
                  Cancelar
                </button>
                <button
                  className="btn btn-success"
                  onClick={saveDataResponsibleAndCloseModal}
                >
                  <span
                    className={
                      isLoadingChange ? " spinner-border spinner-border-sm" : ""
                    }
                  ></span>{" "}
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modalChangePassIsOpen}
          style={{
            content: {
              width: "40%",
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
            },
          }}
          contentLabel="Modal Senha"
        >
          <div className="row">
            <div className="col-12">
              <h3>{selectedGridRow?.nome}</h3>
              <div className="form-group">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-3">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Senha</label>
                        <input
                          type="password"
                          className="form-control"
                          aria-describedby="emailHelp"
                          value={senha}
                          onChange={(e) => setSenha(e.target.value)}
                        />
                        {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          Confirmação de senha
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          value={confirmSenha}
                          onChange={(e) =>
                            setConfirmHandleChange(e.target.value)
                          }
                        />
                        {divergentPasswords && (
                          <small
                            id="emailHelp"
                            className="form-text text-muted text-danger"
                          >
                            Senha e confirmação não podem ser diferentes.
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <button className="btn btn-primary" onClick={cancelModal}>
                  Cancelar
                </button>
                &nbsp;
                <button
                  className="btn btn-success"
                  onClick={changePassAndCloseModal}
                >
                  <span
                    className={
                      isLoadingChange ? " spinner-border spinner-border-sm" : ""
                    }
                  ></span>{" "}
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <NavBarNotificationBar />
        </nav>
        <AsideLeft option="users" />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 text-dark">Usuários</h1>
                </div>
                <div className="col-sm-6">
                  <button className="btn btn-primary pull-right" onClick={()=> createNewUserClick()}>Novo usuário</button>
                </div>

              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                {/* Left col */}
                <section className="col-lg-12 connectedSortable">
                  {/* Custom tabs (Charts with tabs)*/}
                  <div className="card">
                    <div className="card-header">
                      {/* <div className="card-tools">
                                                <ul className="nav nav-pills ml-auto">
                                                    <li className="nav-item">
                                                        <a className="nav-link active" href="/venda/nova" data-toggle="tab">Nova</a>
                                                    </li>
                                                </ul>
                                            </div> */}
                    </div>
                    <div className="card-body">
                      {!usersResult ? (
                        renderLoad()
                      ) : (
                        <div className="tab-content p-0">
                          <DataTable
                            value={usersResult}
                            rowHover
                            paginator
                            rows={20}
                            lazy={true}
                            first={first}
                            onPage={(event) => onPage(event)}
                            onFilter={onFilter}
                            filters={filters}
                            totalRecords={totalRecords}
                            rowsPerPageOptions={[20, 40, 50]}
                            style={{ marginBottom: 50 }}
                            responsive
                            className="p-datatable-customers"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                            emptyMessage="Não existem dados para exibir"
                          >
                            <Column field="id" header="Código" />
                            <Column field="nome" header="Nome" filter={true} />
                            <Column
                              field="email"
                              header="Usuário"
                              filter={true}
                            />
                            <Column
                              field={(row) => getTypeUser(row.typeUser)}
                              header="Tipo"
                            />
                            <Column
                              field={(row) => getStatus(row.status)}
                              header="Status"
                            />
                            <Column
                              key="123"
                              body={optionButtons}
                              bodyStyle={{
                                textAlign: "center",
                                overflow: "hidden",
                              }}
                            />
                          </DataTable>
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}
